import { render } from "./AccountingPage.vue?vue&type=template&id=94d498ba&scoped=true"
import script from "./AccountingPage.vue?vue&type=script&lang=js"
export * from "./AccountingPage.vue?vue&type=script&lang=js"

import "./AccountingPage.vue?vue&type=style&index=0&id=94d498ba&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d498ba"]])

export default __exports__